import React, { useState } from "react";
import ico_resultados_beneficios from '../assets/icons/ico_resultados_beneficios.svg';
import ico_ubicacion from '../assets/icons/ico_ubicacion.svg';
const ToolsTab = (props) => {
    const { firstTitle, secondTitle, firstTab, secondTab } = props;
    const [activeStatus, setActiveStatus] = useState(1);
    return (
        <div className="mt-20 h-fit relative w-full lg:px-10 md:px-0 sm:px-0 px-0">
            <div className=" w-fit ">
                <ul className="flex">
                    <li onClick={() => setActiveStatus(1)} className="lg:mr-32 md:mr-24 sm:mr-10 mr-10  w-full">
                    <a  class={activeStatus == 1 ? "inline-flex lg:text-2xl md:text:lg: sm:text-base text-sm cursor-pointer font-bold items-center pb-20 rounded-t-lg border-b-4  border-blue-600 active text-white dark:border-blue-500 group"
                        : 
                        "inline-flex lg:text-2xl md:text:lg: sm:text-base text-sm font-bold cursor-pointer items-center  text-white  "}>
                            <img loading="lazy" src={ico_ubicacion} className="lg:h-24 md:h-20 sm:h-14 h-14 mr-5"></img>
                            {firstTitle}
                        </a>
                    </li>
                    <li onClick={() => setActiveStatus(2)} className="  w-full">
                        <a  class={activeStatus == 2 ? "inline-flex lg:text-2xl md:text:lg: sm:text-base text-sm cursor-pointer font-bold items-center pb-20 rounded-t-lg border-b-4 border-blue-600  active text-white dark:border-blue-500 group"
                        : 
                        "inline-flex lg:text-2xl md:text:lg: sm:text-base text-sm font-bold cursor-pointer items-center   text-white "}>
                            <img loading="lazy" src={ico_resultados_beneficios} className="lg:h-24 md:h-20 sm:h-14 h-14 mr-5"></img>
                            {secondTitle}
                        </a>
                    </li>
                </ul>
                <div className="relative">
                    <div className="w-auto mr-10 relative border-t border-[#009269]"></div>
                </div>
                <span className="text-lg text-white  lg:mr-36 mt-5 absolute">{activeStatus == 1 && firstTab}</span>
                <span className="text-lg text-white  lg:mr-36 mt-5 absolute">{activeStatus == 2 && secondTab}</span>
            </div>
        </div>
    );
};
export default ToolsTab;